import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded-md border-gray-500 border-dotted w-[90%] h-[90%] flex items-center justify-center relative top-[5%] left-[5%]\"><div><div class=\"text-gray-400 w-fit m-auto\"><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-12 h-12\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z\"></path></svg></div><span class=\"font-bold\">Choose a file</span><br>or drag it here. </div></div>", 1)
const _hoisted_2 = [
  _hoisted_1
]

import { ref } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropFile',
  emits: ["select"],
  setup(__props, { emit: emits }) {

const store = useStore();
const highlight = ref(false);



function files(fileList: FileList) {
	const files: File[] = [];
	for (let i = 0; i < fileList.length; i++) {
		const file = fileList.item(i);
		if (file && file.type.startsWith('image/')) {
			files.push(file);
		}
	}
	return files;
}

function selectImages(e: Event) {
	const fileInput = e.target as HTMLInputElement;
	if (fileInput && fileInput?.files?.length) {
		emits('select', files(fileInput.files));
		fileInput.value = '';
	}
}

function dropFile(e: DragEvent) {
	e.stopPropagation();
	e.preventDefault();
	try {
		const fileList = e.dataTransfer?.files;
		if (!fileList) {
			throw Error('Invalid files');
		}
		emits('select', files(fileList));
	} catch (error) {
		store.dispatch('alert', { type: 'success', message: 'You can drop only file on this zone!' });
	} finally {
		highlight.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", {
      for: "select-file",
      class: _normalizeClass(
			'min-w-[8rem] min-h-[8rem] aspect-square rounded-md bg-white hover:bg-green-200 ease-in duration-200 cursor-pointer' +
			(highlight.value ? ' !bg-green-200' : '')
		),
      draggable: "true",
      onDragover: _cache[0] || (_cache[0] = 
			(e) => {
				e.preventDefault();
				highlight.value = true;
			}
		),
      onDragleave: _cache[1] || (_cache[1] = 
			(e) => {
				e.preventDefault();
				highlight.value = false;
			}
		),
      onDrop: dropFile
    }, _hoisted_2, 34),
    _createElementVNode("input", {
      id: "select-file",
      type: "file",
      multiple: "",
      accept: "image/*",
      hidden: "",
      onChange: selectImages
    }, null, 32)
  ], 64))
}
}

})